import { Heart, Shield, Users, Wrench, Zap, TrendingUp } from 'lucide-react';

const CoreValues = () => {
  const values = [
    {
      icon: Shield,
      title: "Reliability",
      description: "We show up when we say we will. Whether it's a last-minute delivery or a scheduled pick-up, our customers count on us to get the job done right, on time."
    },
    {
      icon: Heart,
      title: "Integrity",
      description: "We believe in honest communication, fair pricing, and doing what's right — even when no one's watching."
    },
    {
      icon: Users,
      title: "Community First",
      description: "As a proud locally owned company, we support and serve our Calgary community with pride, treating every client like a neighbor."
    },
    {
      icon: Wrench,
      title: "Hard Work",
      description: "We're not afraid to get our hands dirty. From small hauls to tougher jobs, we tackle every task with grit and dedication."
    },
    {
      icon: Zap,
      title: "Flexibility & Adaptability",
      description: "We understand that not all deliveries are planned. That's why we're building our reputation as Calgary's go-to for last-minute and custom delivery solutions."
    },
    {
      icon: TrendingUp,
      title: "Growth-Oriented",
      description: "We're just getting started. With every job, we learn, improve, and expand—working toward becoming Calgary's #1 trusted delivery and hauling service."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16" data-testid="core-values-header">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Our Core <span className="gold-gradient">Values</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            The principles that drive everything we do at YYC Pick-Up
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div 
                key={index}
                className="bg-[#1a1a1a] rounded-xl p-8 border border-gray-800 hover:border-[#d4af37] transition-all duration-300 hover:transform hover:scale-105"
                data-testid={`core-value-${index}`}
              >
                <div className="flex items-center mb-4">
                  <div className="bg-[#d4af37]/10 p-3 rounded-lg mr-4">
                    <IconComponent className="w-8 h-8 text-[#d4af37]" />
                  </div>
                  <h3 className="text-xl font-bold text-white">{value.title}</h3>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
